<template>
  <div>
    <search-bar :hasTitle="false" :backgroundColorGray="false"></search-bar>
    //
    <div class="banner-about">
      <img src="../../static/images/banner-6.png" alt>
    </div>

    <section class="section-gray">
      <div class="container">
        <div class="row">
          <div class="col-lg-6">
            <h1 class="text-center text-lg-left">Programa Fast Lube Descarte Responsável</h1>
            <p>Nós da Fast Lube, estamos comprometidos não apenas em fornecer produtos de qualidade, mas também em promover práticas sustentáveis em todas as áreas de nossas operações. Como parte desse compromisso, gostaríamos de compartilhar informações importantes sobre o descarte responsável dos filtros de óleo.</p>
            <p>Os filtros de óleo, essenciais para o bom funcionamento de veículos e equipamentos, requerem uma abordagem cuidadosa quando chega o momento de sua substituição.</p>
          </div>
        </div>
        <div class="row mt-5">
          <div class="col-lg-6">
            <h2 class="text-center text-md-left">Pontos de Coleta</h2>
            <p class="mt-4"> A Fast Lube possui pontos de coleta para facilitar o descarte seguro do filtro de óleo usado, a fim de garantir a destinação correta desses materiais. É importante lembrar que filtros de óleo automotivos são classificados como <b>Resíduos Perigosos Classe I</b>, devido ao seu potencial de contaminação ambiental. O descarte inadequado pode causar sérios danos ao solo e aos recursos hídricos, além de riscos à saúde humana.</p>
            <p>Assim, depositar o filtro usado em pontos de coleta apropriados como este é essencial para contribuir com a proteção ambiental e o bem-estar da comunidade.</p>
            <p>Em nossos pontos de coleta você encontrará coletores identificados e colaboradores instruídos para te auxiliar no momento do descarte.</p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <h5 class="mt-4">Endereços</h5>
            <ul>
              <li class="my-4">
                <p class="brand-secondary">RODACENTRO SUPER TROCA DE ÓLEO LTDA-ME</p>
                <p>RUA FIDALGA, 259 – VILA MADALENA</p>
                <p>05432-070 SÃO PAULO, SP</p>
              </li>
              <li>
                <p class="brand-secondary">SUPER TROCA DE ÓLEO 2000 LTDA</p>
                <p>RUA SANTA CRUZ, 2000 – SAÚDE</p>
                <p>04122-002 SÃO PAULO, SP</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <div class="diagonal-line diagonal-line2"></div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";

export default {
  name: "ResponsibleDisposal",
  components: { SearchBar }
};
</script>



// WEBPACK FOOTER //
// src/pages/ResponsibleDisposal.vue